import FeatherIcon from 'feather-icons-react';
import { useState } from 'react';
import { Button, Col, Modal as ModalComponent } from 'react-bootstrap';

import SubmitButton from '../../components/Buttons/SubmitButton';

interface UserSuccessModalProps {
  show: boolean;
  handleClose: () => void;
  password: string;
}

const UserSuccessModal = ({ show, handleClose, password }: UserSuccessModalProps) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);

  const handleCopyPassword = () => {
    navigator.clipboard.writeText(password);
    setCopied(true);
  };

  return (
    <ModalComponent show={show} onHide={handleClose} centered>
      <ModalComponent.Header className="d-flex justify-content-center">
        <h2 className="card-header-title mt-3">User Registration Successful</h2>
      </ModalComponent.Header>
      <ModalComponent.Body className="p-4 text-center">
        <p>
          Copy and share the temporary password with the new user for their first login. Encourage users to change this
          password on first login.
        </p>
        <div className=" mt-3 gap-3">
          <strong>Password:</strong>
          <span className="mx-2">{passwordVisible ? password : '••••••••'}</span>
          <Button variant="outline-primary" onClick={togglePasswordVisibility} className="me-2">
            <FeatherIcon icon={passwordVisible ? 'eye-off' : 'eye'} size={16} />
          </Button>
          <Button variant="outline-primary" onClick={handleCopyPassword}>
            <FeatherIcon icon="copy" size={16} />
          </Button>
        </div>
      </ModalComponent.Body>
      <ModalComponent.Footer className="py-3">
        <Col className="d-grid">
          <SubmitButton buttonText="Close" onClick={handleClose} loading={false} disabled={!copied} />
        </Col>
      </ModalComponent.Footer>
    </ModalComponent>
  );
};

export default UserSuccessModal;
